import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useEffect } from "react";

import DotMenuButton from "../common/DotMenuButton";
import { useCustomAlertStore, useProjectMEditStore } from "../../Store/store";
import { deleteProjectManager } from "../../api/ProjectAPI";

const Article = styled(Link)`
  text-decoration: none;
  display: block;
  padding: 20px;
  background: #303231ad;
  border-radius: 8px;
  color: white;
  width: 100%;
  box-sizing: border-box;
  min-width: 300px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  z-index: 1000;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
`;

const TitleSection = styled.section`
  display: flex;
  align-items: flex-start;
  flex: 1;

  &::before {
    content: "";
    width: 4px;
    height: 40px;
    background: #4caf50;
    margin-right: 12px;
    border-radius: 2px;
  }
`;

const TitleContent = styled.div`
  h2 {
    margin: 0 0 8px 0;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #ccc;
  }
  @media (max-width: 600px) {
    h2 {
      font-size: 16px;
    }
    p {
      font-size: 12px;
    }
  }
`;

const Footer = styled.footer`
  border-top: 1px solid #444;
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  time {
    font-size: 12px;
    color: #999;
  }
`;

const TaskCounter = styled.p`
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 10px;
  span {
    font-size: 40px;
    font-weight: 500;
  }

  @media (max-width: 600px) {
    font-size: 13px;
    span {
      font-size: 30px;
    }
  }
`;

export default function ProjectCard({
  index,
  projectName,
  projectDescription,
  createdAt,
  projectCount,
  setReload,
}) {
  const { setIsProjectMEditOpen, setProjectManagerId } = useProjectMEditStore();
  const { showSuccessAlert, showErrorAlert, showConfirmAlert } =
    useCustomAlertStore();
  const datePart = createdAt.split(" ")[0];
  const formattedDate = datePart.split("-").join(".");

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsProjectMEditOpen(true);
    setProjectManagerId(index);
  };

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setProjectManagerId(index);

    const handleDelete = async () => {
      try {
        const response = await deleteProjectManager(index);
        if (response.success) {
          showSuccessAlert("삭제 완료", "프로젝트 매니저가 삭제되었습니다.");
          setReload((prev) => !prev);
        }
      } catch (error) {
        showErrorAlert("삭제 실패", "프로젝트 매니저 삭제에 실패했습니다.");
      }
    };

    showConfirmAlert("삭제", "정말 삭제하시겠습니까?", () => {
      handleDelete();
    });
  };

  return (
    <Article to={`/project/task/${index}`}>
      <Header>
        <TitleSection>
          <TitleContent>
            <h2>{projectName}</h2>
            <p>{projectDescription}</p>
          </TitleContent>
        </TitleSection>
        <DotMenuButton
          handleEditClick={handleEditClick}
          handleDeleteClick={handleDeleteClick}
        />
      </Header>
      <TaskCounter>
        <span>{projectCount}</span> 개 태스크
      </TaskCounter>
      <Footer>
        <time dateTime={formattedDate}>{formattedDate}</time>
      </Footer>
    </Article>
  );
}
